import { Injectable } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { EagerSelectEffects } from '../../select/eager-select/eager-select-effects';
import { extensionTypeOptionActions } from './extension-type-option.actions';
import { extensionTypeOptionSelectors } from './extension-type-option.reducer';

@Injectable({ providedIn: 'root' })
export class ExtensionTypeOptionEffects {
   defaultFields: string[] = ['name', 'extensionTypeId', 'displayName'];

   defaultOrderingOptions: string[] = ['displayName:asc'];

   staticFilters: string[] = [];

   load = this.eagerSelectEffects.createEagerSelectorLoadEffect(
      extensionTypeOptionSelectors.selectState,
      'extensiontypes',
      this.defaultFields,
      this.defaultOrderingOptions,
      extensionTypeOptionActions,
      this.staticFilters
   );

   constructor(private eagerSelectEffects: EagerSelectEffects<AppState>) {}
}
